import { ChevronDown } from "lucide-react";
import { ReactNode } from "react";

interface Props {
  value: string;
  onChange: (v: string) => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  ariaLabel?: string;
  wrapperClassName?: string;
}

export default function AppSelect({ value, onChange, children, className, disabled, ariaLabel, wrapperClassName }: Props) {
  return (
    <div className={`relative ${wrapperClassName ?? ""}`}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-label={ariaLabel}
        className={`w-full appearance-none bg-surface-muted border border-border rounded-xl pl-3 pr-9 py-2 text-sm text-foreground font-inter focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary/30 transition-colors ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:border-muted-foreground"} ${className ?? ""}`}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
    </div>
  );
}
